<template>
    <div id="BillView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar"> <!--right sidebar-->
            <div class="right-asset-tab-list purchase-order-right-tab">
                <div id="tabs" class="containerTab">
                    <div class="tabs">
                        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]"> Invoice Details </a>
                        <a v-on:click="activityLogs(bill_id)" v-bind:class="[ activetab === 2 ? 'active' : '' ]"> Activity </a>
                    </div>
                    <div class="content">
                        <div v-if="activetab === 1" class="tabcontent">
                            <div class="list-view">
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">#Invoice:</label>
                                    <span class="col">{{billNum}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">#Voucher:</label>
                                    <span class="col">{{voucherNum}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">Vendor:</label>
                                    <span class="col">{{vendor}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="assignee != ''">
                                    <label class="col">Assignee:</label>
                                    <span class="col">{{assignee}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                    <label class="col">Type:</label>
                                    <span class="col" v-if="vendor_inv_type == 'sublet_invoice'">Sublet Invoice</span>
                                    <span class="col" v-else-if="vendor_inv_type == 'debt_note'">Debt Note</span>
                                    <span class="col" v-else>{{titleCase(vendor_inv_type)}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                    <label class="col">Status:</label>
                                    <span class="col">{{titleCase(status)}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                    <label class="col">Invoice Date:</label>
                                    <span class="col">{{bill_date}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                    <label class="col">Due Date:</label>
                                    <span class="col">{{due_date}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="vendor_inv_type != '' && (vendor_inv_type.toLowerCase() != 'default' || (vendor_inv_type.toLowerCase() == 'default' && is_misc_po == 1))">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">PO:</label>
                                    <span class="col">{{poNum}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="post_period != ''">
                                    <label class="col">Period:</label>
                                    <span class="col">{{post_period}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="work_order_no != ''">
                                    <label class="col">Work Order:</label>
                                    <template v-if="work_order_no != ''">
                                        <span class="col">
                                            <router-link title="View WO" class="color-blue" v-bind:to="{name: 'WorkOrderView',params:{id:work_order_id},query:{fromUrl:frmUrl}}">{{work_order_no}}</router-link>
                                            <!-- {{work_order_no}} -->
                                            <template v-if="work_order_status != ''">
                                                | {{work_order_status}}
                                            </template>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span class="col">-</span>
                                    </template>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3" v-else-if="receipt_number != ''">
                                    <label class="col">PO Receipt:</label>
                                    <template v-if="receipt_number != ''">
                                        <span class="col">
                                            <router-link title="View WO" class="color-blue" v-bind:to="{name: 'RecordReceiptView',params:{id:por_id},query:{fromUrl:frmUrl}}">{{receipt_number}}</router-link>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span class="col">-</span>
                                    </template>
                                </div>
                                <!-- <div class="row form-group border-bottom pb-2 pl-3 pr-3" v-else-if="debt_note_obj != undefined && debt_note_obj.length">
                                    <label class="col">Debt Note:</label>
                                    <template v-for="(dn,dnkey) in debt_note_obj">
                                        <span class="col" :key="dnkey">
                                            <span v-if="dnkey != 0"> | </span>
                                            <router-link title="View Debt Note" class="color-blue" v-bind:to="{name: 'DebtNoteInteresetView',params:{id:dn.dn_id},query:{fromUrl:frmUrl}}">{{dn.dn_number}}</router-link>
                                        </span>
                                    </template>
                                </div> -->
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Notes:</label>
                                    <span class="col">{{titleCase(notes)}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Location :</label>
                                    <span class="col">{{location}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col"> Sub Total: </label>
                                    <span class="col"> {{subTotal}} </span>
                                </div>
<!--                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">-->
<!--                                    <label class="col"> Tax Amount: </label>-->
<!--                                    <span class="col"> ${{totalTax.toFixed(2)}} </span>-->
<!--                                </div>-->
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col"> Total: </label>
                                    <span class="col"> {{total}} </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                            <bill-activity-log-list :activityLogVal="activityLogsTabValue"></bill-activity-log-list>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!--right sidebar-->

        <div id="page-content-wrapper" class="admin-content-area purchase-order-left-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name purchase-order-title">
                    <div class="page-title"> Vendor Invoice Details</div>
                    <div class="btn-groups text-right">
                        <template v-if="!isCrmSection">
                        <template v-if="vendor_inv_type == 'sublet_invoice'">
                            <template v-if="work_order_status.toLowerCase() != 'closed' && work_order_status.toLowerCase() != 'approved'">
                                <button v-if="((canUpdateVendorInvoice && status.toLowerCase() == 'entered') || updateVerifiedInvoice)" type="submit" id="editBillBtn" v-on:click="editbill(bill_id)" class="btn btn-primary">
                                    <i class="fp-edit-icon"></i>  Edit
                                </button>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="vendor_inv_type != 'debt_note'">
                                <button v-if="((canUpdateVendorInvoice && status.toLowerCase() == 'entered') || (updateVerifiedInvoice && status.toLowerCase() == 'verified') || (updateVerifiedInvoice && status.toLowerCase() == 'approved' ))" type="submit" id="editBillBtn" v-on:click="editbill(bill_id)" class="btn btn-primary">
                                    <i class="fp-edit-icon"></i>  Edit
                                </button>
                            </template>
                        </template>
                        <button v-if="canVerifyVendorInvoice && status.toLowerCase() == 'entered'" type="submit" id="editBillBtn" v-on:click.prevent="verifyVendorInvoice('verified')" class="btn btn-tertiary">
                            Verify Invoice
                        </button>
                          <template v-if="can_verify_invoice === 'true'">
                            <button v-if="canVerifyVendorInvoice && status.toLowerCase() == 'verified'" type="submit" id="unverifyBillBtn" v-on:click.prevent="verifyVendorInvoice('entered')" class="btn btn-tertiary">
                              Unverify Invoice
                            </button>
                          </template>
                        <a href="javascript:void(0)" v-if="vendor_inv_type == 'item'" class="btn btn-secondary" v-on:click="previewBarcode()">
                            <i class="fp-print"></i> Preview Barcode
                        </a>
                        </template>
                        <a href="javascript:void(0)" v-if="canAddCrm" class="btn btn-secondary" v-on:click.prevent="crmSection()">
                            <i class="fp-agreement"></i> {{crmBtnTitle}}
                        </a>
                        <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'BillList'}">
                            <i class="fp-back"></i>  Back
                        </router-link> -->
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="backBtn()" >
                                <i class="fp-back"> </i> Back
                            </button>
                    </div>
                </div>
                <template v-if="!isCrmSection">
                <div v-if="!showBarcode" class="container-fluid">
                    <div id="workorder-detail work-order-view-top" class="admin-page-content bill-view">
                        <section class="internal-container border-top-table-fl">
                            <template v-if="billItemsArr && billItemsArr.length == 0">
                                <div class="lineitem-main-section">
                                    <h5>No Line Item Added</h5>
                                </div>
                            </template>
                            <template v-else>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="billItemsArr != undefined && billItemsArr.length > 0">
                                        <thead>
                                            <tr class="table-primary">
                                                <template v-if="vendor_inv_type == 'item'">
                                                    <th>Part</th>
                                                </template>
                                                <template v-else-if="vendor_inv_type == 'sublet_po'">
                                                    <th>Description</th>
                                                    <th>Part</th>
                                                </template>
                                                <template v-else-if="vendor_inv_type == 'equipment'">
                                                    <th v-if="unit_no != ''">Unit</th>
                                                    <th v-else>Description</th>
                                                </template>
                                                <template v-else-if="vendor_inv_type == 'sublet_invoice'">
                                                    <th>Description</th>
                                                    <th>Unit No.</th>
                                                    <th class="text-right">Labor Amount</th>
                                                    <th class="text-right">Part Amount</th>
                                                </template>
                                                <template v-else>
                                                    <th>GL Account</th>
                                                    <th class="text-right" v-if="vendor_inv_type == 'default' && is_misc_po == 1">Quantity</th>
                                                    <th class="text-right" v-if="vendor_inv_type == 'default' && is_misc_po == 1">Unit Price</th>
                                                    <th class="text-right">Amount</th>
                                                    <th>Description</th>
                                                </template>
                                                <!-- <th>GL Account</th> -->
                                                <template v-if="vendor_inv_type != 'sublet_invoice' && vendor_inv_type != 'default' && vendor_inv_type != 'debt_note'">
                                                    <th class="text-right">Quantity</th>
                                                    <th class="text-right">Unit Price</th>
                                                    <th class="text-right">Amount</th>
                                                <!-- <th class="text-right">Tax</th> -->
                                                </template>
                                                <template v-if="vendor_inv_type == 'item' || vendor_inv_type == 'default'">
                                                    <th>Unit No.</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in billItemsArr" v-bind:key="index">
                                                <template v-if="vendor_inv_type == 'item'">
                                                    <td> {{ item.part}} </td>
                                                </template>
                                                <template v-else-if="vendor_inv_type == 'sublet_po'">
                                                    <td> {{ item.description}} </td>
                                                    <td> {{ item.part}} </td>
                                                </template>
                                                <template v-else-if="vendor_inv_type == 'equipment'">
                                                    <td> {{ item.description}} </td>
                                                </template>
                                                <template v-else-if="vendor_inv_type == 'sublet_invoice'">
                                                    <td> {{ item.description}} </td>
                                                    <td> {{ item.vehicle_id}} </td>
                                                    <td class="text-right"> {{ amountFormat(item.labor)}} </td>
                                                    <td class="text-right"> {{ amountFormat(item.materials)}} </td>
                                                </template>
                                                <template v-else>
                                                    <td> {{ item.gl_account}} </td>
                                                    <td class="text-right" v-if="vendor_inv_type == 'default' && is_misc_po == 1"> {{ item.quantity}} </td>
                                                    <td class="text-right" v-if="vendor_inv_type == 'default' && is_misc_po == 1"> {{ amountFormat(item.unit_price)}} </td>
                                                    <td class="text-right"> {{ amountFormat(item.sub_total)}} </td>
                                                    <td> {{ item.description}} </td>
                                                </template>
                                                <!-- <td> {{ item.gl_account}} </td> -->
                                                <template v-if="vendor_inv_type != 'sublet_invoice' && vendor_inv_type != 'default' && vendor_inv_type != 'debt_note'">
                                                    <td class="text-right"> {{ item.quantity}} </td>
                                                    <td class="text-right"> {{ amountFormat(item.unit_price)}} </td>
                                                    <td class="text-right"> {{ amountFormat(item.sub_total)}} </td>
                                                <!-- <td class="text-right"> {{ item.tax_id }} </td> -->
                                                </template>
                                                <template v-if="vendor_inv_type == 'item' || vendor_inv_type == 'default'">
                                                    <td> {{ item.vehicle}} </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- <template v-if="disrows && disrows.length > 0">
                                        <h4 class="mt-4">Discount</h4>
                                        <div class="table-responsive-sm">
                                            <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="disrows != undefined && disrows.length > 0">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>Description</th>
                                                        <th>GL Account</th>
                                                        <th class="text-right">Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(dis, dindex) in disrows" v-bind:key="dindex">
                                                        <td> {{ dis.description}} </td>
                                                        <td> {{ dis.gl_account}}</td>
                                                        <td class="text-right"> {{ amountFormat(dis.discount)}} </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template> -->
                                    <template v-if="vendor_inv_type != 'default' && chargeItemArr && chargeItemArr.length > 0">
                                        <div class="table-responsive-sm">
                                            <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="chargeItemArr != undefined && chargeItemArr.length > 0">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>Charge</th>
                                                        <template v-if="vendor_inv_type == 'equipment'">
                                                            <th>Unit#</th>
                                                        </template>
                                                        <th class="text-right">Qty/Hours</th>
                                                        <th class="text-right">Unit Price</th>
                                                        <th class="text-right">Amount</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(charge, chindex) in chargeItemArr" v-bind:key="chindex">
                                                        <td> <p v-if="charge.charge_id">{{ charge.charge_id}}</p><p v-else>-</p> </td>
                                                        <td v-if="vendor_inv_type == 'equipment'">{{ charge.unit_no }}</td>
                                                        <td class="text-right"> {{ charge.quantity}} </td>
                                                        <td class="text-right"> ${{ amountFormat(charge.unit_price.toFixed(2))}} </td>
                                                        <td class="text-right"> {{ currencyFormat(charge.total)}} </td>
                                                        <!-- <td class="text-right"> ${{ charge.unit_price.toFixed(2)}} </td>
                                                        <td class="text-right"> ${{ charge.total.toFixed(2)}} </td> -->
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>

                                    <template v-if="transactionArr && transactionArr.length > 0">
                                        <strong>Transaction Detail</strong>
                                        <div class="table-responsive-sm">
                                            <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="transactionArr != undefined && transactionArr.length > 0">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>Transaction</th>
                                                        <th>Description</th>
                                                        <th>Date</th>
                                                        <th class="text-right">Discount</th>
                                                        <th class="text-right">Amount</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(tr, tindex) in transactionArr" v-bind:key="tindex">
                                                    <template v-if="tr.amount != null">
                                                        <td> {{ tr.transaction}}</td>
                                                        <td> {{ tr.description}} </td>
                                                        <td> {{ tr.date}} </td>
                                                        <td class="text-right"> {{ tr.discount}} </td>

                                                          <td class="text-right"><span v-if="tr.type == 'payment'">-</span> ${{ tr.amount.toFixed(2)}} </td>
                                                    </template>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </section>
                        <div class="internal-container border-top-table-fl mt-4">
                            <h5> Attachments </h5>
                            <div class="attachment-view-internal-section">
                                <template v-if="files && files.length > 0">
                                    <template v-for="(doc,vkey) in files">
                                        <div v-bind:key="'fileDiv'+vkey" class="attachment-list mt-2">
                                            <i v-if="doc.ext == 'pdf'" class="fp-pdf-icon"></i>
                                            <i v-if="doc.ext == 'doc' || doc.ext == 'docs'" class="fp-text-document"></i>
                                            <i v-if="doc.ext == 'jpg' ||  doc.ext == 'png' ||  doc.ext == 'jpeg' " class="fp-image"></i>
                                            <a :key="vkey" href="javascript:void(0)" class="customer-detail-rv" v-on:click="openDocument(doc.url,doc.ext)">  {{doc.name}}</a>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                          <template v-if="can_delete_attachment === 'true'">
                                            <button type="button"  v-bind:key="'cancelBtn'+vkey" v-on:click="deleteBillFile(vkey,doc.path);">
                                              <i class="fp-remove"></i>
                                            </button>
                                          </template>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="custom-dropzone-container custom-photo-user-dropzone dropzone-margin">
                                        <label class="control-label" for="documents">Documents (.jpg, .jpeg, .png, .pdf, .doc and .docx files are allowed)</label>
                                        <div id="app2">
                                            <vue-dropzone
                                                id="vendorInvoiceDocs"
                                                :options="dropzoneOptions"
                                                :destroyDropzone=false
                                                ref="vendorInvoiceDropzone"
                                                :headers="dropzoneOptions.headers"
                                                @vdropzone-complete="afterComplete"
                                                @vdropzone-success="storeDocument"
                                                @vdropzone-removed-file="removedSelectedFile"
                                                >
                                            </vue-dropzone>
                                        </div>
                                        <div class="field-error">{{doc_error_msg}}</div>
                                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="invoiceDocForm">
                                            <div class="btn-groups">
                                                <button type="submit" id="uploadVendorInvDoc" class="btn btn-primary" v-on:click.prevent="storeBillDoc">
                                                    <i class="fp-save"> </i> Save
                                                </button>
                                            </div>
                                        </form>    
                                    </div>    
                                </template>
                            </div>
                        </div>
                        <!--Work Order GL -->
                        <template v-if="workOrderGLArr && workOrderGLArr.length > 0">
                            <section class="internal-container border-top-table-fl mt-4 loader-position" v-if="canViewGL">
                                <div class="journal-title">
                                    <h5> {{woGlTitle}} <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#wo_gl'"></i>   </h5>
                                </div>
                                <div :id="'wo_gl'" class="accordian-body collapse show">
                                    <div class="table-reponsive-sm">
                                        <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm purchase-order-item-table font-1" >
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Account</th>
                                                    <th class="text-right">Debit</th>
                                                    <th class="text-right">Credit</th>
                                                    <th class="text-right">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="workOrderGLArr != undefined && workOrderGLArr.length > 0">
                                                <template v-for="(woItem , woKey) in workOrderGLArr">
                                                    <tr :key="'wo_gl_item'+woKey">
                                                        <template v-if="woItem.account_description == 'Total'">
                                                            <td class="text-right">{{woItem.account_description}}</td>
                                                        </template>
                                                        <template v-else>
                                                            <td>{{woItem.account_description}}</td>
                                                        </template>
                                                        <td class="text-right">{{woItem.debit}}</td>
                                                        <td class="text-right">{{woItem.credit}}</td>
                                                        <td class="text-right">{{woItem.journal_amount}}</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td colspan="4"><h5>No GL Found</h5></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>    
                                </div>
                            </section>
                        </template>    
                        <!-- Journals -->
                        <section class="internal-container border-top-table-fl mt-4 loader-position" v-if="canViewGL">
                            <div :class="`loader-div${loaderClass}`" v-show="loadingGL"></div>
                            <div class="journal-title">
                                <h5> {{glTitle}} <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i>   </h5>
                            </div>
                            <div :id="'demo'" class="accordian-body collapse show">
                                <div class="table-reponsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm purchase-order-item-table font-1" >
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Account</th>
                                                <th class="text-right">IssuedAt</th>
                                                <th class="text-right">Debit</th>
                                                <th class="text-right">Credit</th>
                                                <th class="text-right">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="journalsArr != undefined && journalsArr.length > 0">
                                            <template v-for="(journalItem , journalKey) in journalsArr">
                                                <tr :key="'journal'+journalKey">
                                                    <template v-if="journalItem.account_description == 'Total'">
                                                        <td class="text-right">{{journalItem.account_description}}</td>
                                                    </template>
                                                    <template v-else>
                                                        <td>{{journalItem.account_description}}</td>
                                                    </template>
                                                    <td class="text-right">{{journalItem.issued_at}}</td>
                                                    <td class="text-right">{{journalItem.debit}}</td>
                                                    <td class="text-right">{{journalItem.credit}}</td>
                                                    <td class="text-right">{{journalItem.journal_amount}}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="4"><h5>No GL Found</h5></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <div v-else>
                     <app-component-barcode :selected="selectedRows" flagPage='bill'></app-component-barcode>
                </div>
                </template>
                <template v-else>
                    <!-- Voucher Crm-->
                    <div class="container-fluid">
                        <div id="bill-crm-list" class="admin-page-content bill-view list-view">
                            <template v-if="crmAdd">
                                <crm-create :fromModule="billObj"></crm-create>
                            </template>
                            <template v-else>
                                <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                                <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                    <div class="bg-white data-table p-0">
                                        <bill-crm-list v-if="enableBillCrm" :moduleVal="'voucher'" :moduleId="bill_id"></bill-crm-list>
                                    </div>
                                </section>
                            </template>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';

import ActivityLogListView from '@/components/ActivityLogList.vue';
import CrmCreate from "@/components/CrmCreate.vue";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
Vue.component("crm-create", CrmCreate);

Vue.component("bill-activity-log-list", ActivityLogListView);


export default {
    name: "BillView",
    // metaInfo: {
    //   // title will be injected into parent titleTemplate
    //   title: "Vendor Invoice View  | " +process.env.COPYRIGHT_NAME
    // },
    components: {
        appComponentBarcode: () => import('@/components/ComponentBarcode'),
        billCrmList: () => import('@/components/CrmList.vue'),
        vueDropzone: vue2Dropzone,
    },
    mixins:[commonMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        billNum:"",
        vendor:"",
        bill_date:"",
        due_date:"",
        amount:0,
        status:"",
        notes:"",
        subTotal:0,
        totalTax:0,
        total:0,
        files:[],
        billItemsArr:[],
        billArr:[],
        activetab: 1,
        activityLogsTabValue: "billloadList",
        activityLoaded:false,
        poNum:'',
        bill_loaded:false,
        location:'',
        journalsArr:[],
        voucherNum:'',
        showMoreLessLabel:"Show More",
        showMoreLessFlag:false,
        disrows:[],
        chargeItemArr:[],
        showBarcode:false,
        selectedRows:[],
        vendor_inv_type:"",
        canVerifyVendorInvoice:false,
        work_order_no:"",
        work_order_id:0,
        work_order_status:"",
        canUpdateVendorInvoice:false,
        canViewGL:false,
        assignee:"",
        isCrmSection:false,
        enableBillCrm:false,
        canAddCrm:false,
        crmAdd:false,
        billObj:{},
        crmBtnTitle:"CRM",
        updateVerifiedInvoice:false,
        transactionArr:[],
        unit_no: "",
        work_order_type:"",
        post_period:"",
        loadingGL:false,
        frmUrl:'',
        receipt_number:'',
        por_id:'',
        // debt_note_obj:'',
        workOrderGLArr:[],
        glTitle:"General Ledger",
        woGlTitle:"Work Order GL Preview",
        is_misc_po:0,
        dropzoneOptions: {
            url: process.env.ROOT_API +"/store-vendor-invoice-docs",
            method: 'POST',
            maxFilesize: 5.00, //MB
            maxFiles: 1,
            thumbnailWidth: 150, // px
            thumbnailHeight: 150,
            addRemoveLinks: true,
            acceptedFiles: ".jpg, .jpeg, .png, .pdf , .doc ,.docx",
            headers: {
                'Accept': 'application/json',
                "Authorization": "Bearer "+localStorage.getItem("tkn"),
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                "Cache-Control": "no-cache"
            },
            dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
            destroyDropzone:false,
            dictDefaultMessage: "Drop files here to upload. Files upto maximum 5 MB size are allowed.",
        },
        uploadDocs:[],
        doc_error_msg:'',
        validateDocs:[],
        can_verify_invoice: 'true',
        can_delete_attachment: 'true',
        isReqInprocess:false,
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'view_vendor_invoice') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'can_verify_vendor_invoice') {
                        self.canVerifyVendorInvoice = true;
                    }
                    if (permissions[i].name == 'add_vendor_invoice') {
                        self.canUpdateVendorInvoice = true;
                    }
                    if (permissions[i].name == 'view_general_ledger') {
                        self.canViewGL = true;
                    }
                    if (permissions[i].name == 'add_crm') {
                        self.canAddCrm = true;
                    }
                    if (permissions[i].name == 'update_verified_vendor_invoice') {
                        self.updateVerifiedInvoice = true;
                    }
                }
            }

        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        self.getPermissions();

        self.showMoreLessLabel = "Show Less"
        self.bill_id = segments[3];
        //set value in bill object for crm
        self.billObj.module = "voucher";
        self.billObj.bill_id = segments[3];
        self.billObj.flag = "add";
        self.billObj.crm_id = "";
        self.loadBillDetail(self.bill_id);
        self.loadBillDiscount();
        this.frmUrl = btoa(window.location.pathname);
    },
    metaInfo() {
        return {
            title: (this.voucherNum != "") ? this.voucherNum + " | Vendor Invoice View | " +process.env.COPYRIGHT_NAME:"Vendor Invoice View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {
        editbill(bill_id){
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.$router.push({name: 'BillEdit',params:{id:bill_id,inv_type:self.vendor_inv_type}});
        },
        loadBillDetail(bill_id) {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/bill-detail/" + bill_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                    if (data.status == "success") {
                        // self.bill_id=data.content.id;
                       self.billObj.vendor_id = data.content.vendor_id;
                       self.billNum = data.content.bill_number;
                       if(data.content.voucher_number != null){
                            self.voucherNum = data.content.voucher_number;
                        }else{
                            self.voucherNum = "-"
                        }

                        if(data.content.vName != null){
                            self.vendor = data.content.vCode +" | "+ data.content.vName+data.content.address;
                        }else{
                            self.vendor = "-"
                        }

                        if(data.content.bill_notes != null){
                            self.notes = data.content.bill_notes;
                        }else{
                            self.notes = "-";
                        }

                        self.bill_date = data.content.bill_date;
                        self.due_date = data.content.due_date;
                        self.amount = data.content.amount;
                        if(data.content.status.includes('_')){

                            self.status = data.content.status.replace('_',' ');

                        }else{

                            self.status = data.content.status;
                        }
                        if (data.content.status != "entered") {
                            self.glTitle = "General Ledger";
                        }
                        if (data.content.locName != null && data.content.locName != "") {
                            self.location = data.content.locCode + " | " + data.content.locName;
                        }else{
                            self.location = "-";
                        }


                        if(data.content.docs != null){
                            self.files = data.content.docs;
                        }
                        self.subTotal = self.currencyFormat(data.content.sub_total);
                        // self.totalTax = data.content.tax_amount;
                        self.total = self.currencyFormat(data.content.total);
                        if (data.content.poTotal != null) {
                            self.poNum = data.content.poNumber+' | '+self.amountFormat(data.content.poTotal);
                        }else{
                            if (data.content.poNumber != null) {
                                self.poNum = data.content.poNumber;
                            }else{
                                self.poNum = "-";
                            }
                        }
                        if (data.content.po_type != undefined) {
                            if (data.content.po_type != null && data.content.po_type != "") {
                                self.vendor_inv_type = data.content.po_type;
                                if (data.content.po_type == "misc") {
                                    self.is_misc_po = 1;
                                }
                            }else{
                                self.vendor_inv_type = "";
                            }
                        }else{
                            self.vendor_inv_type = "";
                        }
                        self.vendor_inv_type = data.content.type;
                        if (data.content.journals != undefined) {
                            self.journalsArr = data.content.journals;
                        }else{
                            self.journalsArr = [];
                        }
                        if (data.content.wo_data != undefined) {
                            if (data.content.wo_data != null) {
                                if (data.content.wo_data.wo_no != undefined && data.content.wo_data.wo_no != null) {
                                    self.work_order_no = data.content.wo_data.wo_no;
                                }
                                if (data.content.wo_data.id != undefined && data.content.wo_data.id != null) {
                                    self.work_order_id = data.content.wo_data.id;
                                }
                                if (data.content.wo_data.wo_status != undefined && data.content.wo_data.wo_status != null) {
                                    self.work_order_status = data.content.wo_data.wo_status;
                                    if (self.work_order_status.toLowerCase() == "approved") {
                                        self.woGlTitle = "Work Order GL";
                                    }
                                }
                                if (data.content.wo_data.wo_type != undefined && data.content.wo_data.wo_type != null) {
                                    self.work_order_type = data.content.wo_data.wo_type;
                                }
                            }
                        }
                        if (data.content.work_order_gl != undefined) {
                            self.workOrderGLArr = data.content.work_order_gl;
                        }else{
                            self.workOrderGLArr = [];
                        }

                        if (data.content.receipt_number != undefined && data.content.receipt_number != null){
                            self.receipt_number = data.content.receipt_number;
                            self.por_id = data.content.por_id;
                        }
                        // if (data.content.debt_note_obj != undefined && data.content.debt_note_obj.length){
                        //     self.debt_note_obj = data.content.debt_note_obj;
                        // }
                        if (data.content.assignee_name != undefined && data.content.assignee_name != null && data.content.assignee_name != "") {
                            self.assignee = data.content.assignee_name + " | " + data.content.assignee_code;
                        }else{
                            self.assignee = "";
                        }
                        self.transactionArr = data.content.transaction;
                        if (data.content.post_period != undefined && data.content.post_period != "") {
                            self.post_period = data.content.post_period;
                        }
                        self.loadBillItem(bill_id);
                        if(self.bill_loaded == false && data.content.vendor_id && data.content.vendor_id!=0 && data.content.vendor_id!="" )
                        {
//                            self.loadVendorBill(data.content.vendor_id);
                            self.bill_loaded=true;
                        }
//                        setTimeout(function () {
                            $("div.bill-data").removeClass("bill-active");
                            $('#bill-data-'+data.content.id).addClass('bill-active');
//                        }, 3500);
                      self.can_verify_invoice = data.content.can_verify_invoice;
                      self.can_delete_attachment = data.content.can_delete_attachment;

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-detail-view');
                }
            });
        },
        loadBillItem(bill_id){
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bill/item/" + bill_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);

                    if (data.status == "success") {

                        self.billItemsArr = [];
                        self.chargeItemArr = [];
                        if(data.content.length>=1) {
                            for (var i = 0; i < data.content.length; i++) {
                                if (data.content[i].charge_id == null){
                                  var desc = '';

                                  if(data.content[i].unit_no !== null) {
                                    self.unit_no = data.content[i].unit_no;
                                    var vin = (data.content[i].description != "" && data.content[i].description != null) ? data.content[i].description : "";
                                    desc = data.content[i].unit_no.toString() + " VIN# - " +  vin;
                                  } else {
                                    desc = (data.content[i].description != "" && data.content[i].description != null) ? data.content[i].description : "-";

                                  }
                                    var unitName = "";
                                    if (data.content[i].veh_unit_no != null && data.content[i].veh_unit_no != "") {
                                        unitName = data.content[i].veh_unit_no;
                                    }
                                    if (data.content[i].unit_name != null && data.content[i].unit_name != "") {
                                        unitName += " | ";
                                        unitName += data.content[i].unit_name;
                                    }



                                    self.billItemsArr.push({
                                        bill_item_id: data.content[i].id,
                                        bill_id: data.content[i].bill_id,
                                        // part: (data.content[i].item_id != undefined && data.content[i].item_id != null && data.content[i].item_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].iName + " (" + data.content[i].iCode +")")}:"-",
                                        part:(data.content[i].iCode != undefined && data.content[i].iCode != null && data.content[i].iCode != '')?self.titleCase(data.content[i].iName + " (" + data.content[i].iCode +")"):"-",
                                        description: desc,
                                        quantity: (data.content[i].item_qty > 0 || data.content[i].item_qty < 0)?self.amountFormat(data.content[i].item_qty):"-",
                                        unit_price: (data.content[i].item_price != 0)?data.content[i].item_price:"-",
                                        tax_percentage: data.content[i].tax_percentage,
                                        tax_amount: data.content[i].tax,
                                        sub_total: data.content[i].item_total + data.content[i].tax,
                                        total: data.content[i].item_total + data.content[i].tax,
                                        gl_account:(data.content[i].accCode != undefined && data.content[i].accCode != null && data.content[i].accCode != '')?self.ucString(data.content[i].accCode + " | " + data.content[i].accDesc):"-",
                                        tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? data.content[i].tax_name: "-",
                                        vehicle:(unitName != "")?unitName:"-"
                                    })
                                }else{
                                    if (data.content[i].bill_type == "sublet_invoice") {
                                        if (data.content[i].type != undefined) {
                                            if (data.content[i].type == "item") {
                                                var unitName = "";
                                                if (data.content[i].unit_no != null && data.content[i].unit_no != "") {
                                                    unitName = data.content[i].unit_no;
                                                }
                                                if (data.content[i].bill_item_id != 0) {//if line item is only from vendor invoice
                                                    self.billItemsArr.push({
                                                        bill_item_id: data.content[i].id,
                                                        bill_id: data.content[i].bill_id,
                                                        part:(data.content[i].iCode != undefined && data.content[i].iCode != null && data.content[i].iCode != '')?self.titleCase(data.content[i].iName + " (" + data.content[i].iCode +")"):"-",
                                                        description:(data.content[i].description != "" && data.content[i].description != null)?data.content[i].description:"-",
                                                        quantity: (data.content[i].item_qty != 0)?self.amountFormat(data.content[i].item_qty):"-",
                                                        vehicle_id:unitName,
                                                        labor:(data.content[i].labor_price != undefined && data.content[i].labor_price != null)?data.content[i].labor_price:0,
                                                        materials:(data.content[i].part_price != undefined && data.content[i].part_price != null)?data.content[i].part_price:0,
                                                    });
                                                }
                                            }else{
                                                self.chargeItemArr.push({
                                                    bill_item_id:data.content[i].id,
                                                    bill_id: data.content[i].bill_id,
                                                    charge_id:(data.content[i].charge_name != undefined && data.content[i].charge_name != null && data.content[i].charge_name != '')?self.titleCase(data.content[i].charge_name):"-",
                                                    quantity: (data.content[i].item_qty != 0)?self.amountFormat(data.content[i].item_qty):"-",
                                                    unit_price: (data.content[i].item_price > 0)?data.content[i].item_price:"-",
                                                    sub_total: data.content[i].item_total + data.content[i].tax,
                                                    total: data.content[i].item_total + data.content[i].tax,
                                                });
                                            }
                                        }
                                    }else{
                                        var unitName = "";
                                        if (data.content[i].veh_unit_no != null && data.content[i].veh_unit_no != "") {
                                            unitName = data.content[i].veh_unit_no;
                                        }
                                        self.chargeItemArr.push({
                                            bill_item_id: data.content[i].id,
                                            bill_id: data.content[i].bill_id,
                                            // part: (data.content[i].item_id != undefined && data.content[i].item_id != null && data.content[i].item_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].iName + " (" + data.content[i].iCode +")")}:"-",
                                            charge_id:(data.content[i].charge_name != undefined && data.content[i].charge_name != null && data.content[i].charge_name != '')?self.titleCase(data.content[i].charge_name):"-",
                                            quantity: (data.content[i].item_qty != 0)?self.amountFormat(data.content[i].item_qty):"-",
                                            unit_price: (data.content[i].item_price > 0)?data.content[i].item_price:"-",
                                            sub_total: data.content[i].item_total + data.content[i].tax,
                                            total: data.content[i].item_total + data.content[i].tax,
                                            unit_no:(unitName != "")?unitName:"-"
                                        })
                                    }
                                }

                            }
                        }
                        //vendor invoice gl entry
                        if (self.status.toLowerCase() != "entered") {    
                            self.loadBillGL();
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-items-view');
                }
            });
        },
        loadVendorBill(vendor_id){
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor/bill/" + vendor_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
//                     console.log(data);

                    if (data.status == "success") {

                        self.billArr = [];
                        if(data.content.length>=1) {
                            self.billArr=data.content;
                            setTimeout(function () {
                                $("div.bill-data").removeClass("bill-active");
                                $('#bill-data-'+self.bill_id).addClass('bill-active');
                            }, 3000);
                            /*for (var i = 0; i < data.content.length; i++) {

                                self.billItemsArr.push({
                                    bill_item_id: data.content[i].id,
                                    bill_id: data.content[i].bill_id,
                                    part: (data.content[i].item_id != undefined && data.content[i].item_id != null && data.content[i].item_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].iName + " (" + data.content[i].iCode +")")}:"-",
                                    description:data.content[i].description,
                                    quantity: data.content[i].item_qty,
                                    unit_price: data.content[i].item_price,
                                    tax_percentage: data.content[i].tax_percentage,
                                    tax_amount: data.content[i].tax,
                                    sub_total: data.content[i].item_total,
                                    total: data.content[i].item_total + data.content[i].tax,
                                })
                            }*/
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoices');
                }
            });
        },
        titleCase(str) {
            if ( str == null ) {
                return "-";
            } else {
                var value = str.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        deleteBillFile: function(key,file){

            var self = this;
            if (confirm('Are you sure that you want to remove file? ')) {

                if(self.bill_id != '' && self.bill_id != undefined){

                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/remove-bill-file",
                        type: "POST",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            bill_id:self.bill_id,
                            doc_path:file
                        },
                        success: function(data) {
                            self.loading = false;
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {

                                self.loadBillDetail(self.bill_id);
                            }
                        },
                        error: function(jqXHR, exception) {
                            self.loading = false;
                            self.files.splice(key,1);
                            self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-doc-remove');
                        }
                    });

                } else{

                    self.filesArr.splice(key,1);
                    self.$refs.files.value = '';


                }
            }
        },
        loadBillDiscount() {

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bill/discount-item/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        self.disrows = [];

                        if (data.content.length >= 1) {
                            var totalDiscount = 0;
                            for (var i = 0; i < data.content.length; i++) {
                                self.disrows.push({
                                    discount_id:data.content[i].id,
                                    description:data.content[i].description,
                                    description_error_msg:"",
                                    discount:parseFloat(data.content[i].discount),
                                    discount_error_msg:"",
                                    gl_account_id:(data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '') ? {
                                        value: data.content[i].gl_account_id,
                                        text: self.ucString(data.content[i].accCode + " | " + data.content[i].accDesc),
                                    } : null,
                                    gl_account_error_msg:"",
                                    gl_account:self.ucString(data.content[i].accCode + " | " + data.content[i].accDesc)
                                });

                            }
                        }

                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-discount');
                }
            });
        },

        activityLogs(bill_id){

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            self.$root.$emit('activity_log_opted','vendor invoice',bill_id);
            self.activityLogsTabValue = "billloadList";// flag value set to loadList so that filters in list work properly.
            self.activetab = 2;
        },

        showMoreLessContent() {
            var self = this;
            if (!self.showMoreLessFlag) {
                self.showMoreLessLabel = "Show Less"
                self.showMoreLessFlag = true;
            }else{
                self.showMoreLessLabel = "Show More"
                self.showMoreLessFlag = false;
            }
        },
        previewBarcode(){
            var self = this;
            self.selectedRows.push(self.$route.query.id);
            self.showBarcode = true;
        },
        verifyVendorInvoice(invStatus) {
            var self = this;
            if ( self.isReqInprocess ) {
                return;
            }
            if (self.bill_id != undefined) {
                if (self.bill_id != null) {
                    if (self.bill_id > 0) {
                        var message = 'Are you sure that you want to verify the Vendor Invoice? ';
                        if (invStatus == 'entered') {
                            message = 'Are you sure that you want to unverify the Vendor Invoice? ';
                        }
                        if (confirm(message)) {
                            var idArr = [];
                            idArr.push(self.bill_id);
                            self.isReqInprocess = true;
                            self.loading = true;
                            $.ajax({
                                url: process.env.ROOT_API + "/bill/change-status",
                                type: "POST",
                                data: {arr:idArr,status:invStatus},
                                headers: this.ajxHeaders,
                                dataType: "json",
                                success: function (data) {
                                    self.loading = false;
                                    self.isReqInprocess = false;
                                    if (data.status == "success") {
                                        if (data.doc_required && data.doc_required.length > 0){
                                            self.$swal('','Document Upload Required.','info');
                                        }
                                        self.loadBillDetail(self.bill_id);
                                    }else if(data.status == "warning"){
                                            self.$swal('',data.message,'info');
                                    }else{
                                        if (data.doc_required && data.doc_required.length > 0){
                                            self.$swal('','Document Upload Required.','info');
                                        }
                                    }
                                },
                                error: function (jqXHR, exception) {
                                    self.loading = false;
                                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-change-status-view');
                                }
                            });
                        }
                    }
                }
            }
        },
        crmSection() {
            var self = this;
            if (!self.isCrmSection) {
                self.isCrmSection = true;
                self.enableBillCrm = true;
                self.crmBtnTitle = "Detail";
            }else{
                self.isCrmSection = false;
                self.enableBillCrm = false;
                self.crmAdd = false;
                self.crmBtnTitle = "CRM";
            }
        },
        addCrm() {
            var self = this;
            self.crmAdd = true;
            self.billObj.crm_id = "";
            self.billObj.flag = "add";
        },
        cancelCrmFromView() {
            var self = this;
            self.crmAdd = false;
        },
        editCrmFromView(crmId){
            var self = this;
            self.crmAdd = true;
            self.billObj.crm_id = crmId;
            self.billObj.flag = "update";
        },
        backBtn() {
            var self = this;
            var url = "/vendor-invoice/list"
            if ( self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined ) {
                url = atob(self.$route.query.fromUrl);
            }else if ( self.$route.query.from != undefined && self.$route.query.from == "gl") {
                url = "/report/general-ledger";
            }else if (self.$route.query.from != undefined && self.$route.query.from == "agreement"){
                url = "/rentalagreement/view/"+self.$route.query.ref;
            }
            self.redirectPageUrl(url);
        },
        loadBillGL() {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            var fields = {
                name:"voucher",
                id:segments[3],
                doc_no:self.voucherNum
            };
            self.loadingGL = true;
            $.ajax({
                url:process.env.ROOT_API + "/module/gl",
                type:"POST",
                data:fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loadingGL = false;
                    if (data.status == "success"){
                        self.journalsArr = data.content;          
                    }
                },
                error: function (jqXHR, exception) {
                    self.loadingGL = false;
                    self.generateStatusCodeMessage(jqXHR,true,'bill-gl')
                }
            });
        },
        afterComplete(file,response){
            var self = this;
        },
        storeDocument(file,response){
            var self = this;
            self.doc_error_msg = "";
            self.uploadDocs = [];
            self.validateDocs = [];
            var uploadResponse = response;

            //push doc path in doc array
            self.uploadDocs.push(uploadResponse.content);
            if (file.type != undefined) {
                var extension = file.type.split("/");
                self.validateDocs.push({
                    file_name:file.name,
                    size:file.size,
                    extension:extension[1]
                });
            }
        },
        removedSelectedFile(file, xhr, error) {
            var self = this;
            self.doc_error_msg = "";
            if (file.xhr != undefined) {
                var fileName = JSON.parse(file.xhr.response).content;

                var fileArr = fileName.split("/");

                self.removeFileFromServer(fileArr[1],"temp");

                for(var i = 0;i<self.uploadDocs.length;i++){
                    if ( self.uploadDocs[i].includes(fileName)) {
                        self.uploadDocs.splice(i,1);
                        self.validateDocs.splice(i,1);
                    }
                }
            }
        },
        removeFileFromServer(file,flag){
            var self = this;
            var billId = self.$route.params.id;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/remove-bill-file",
                type: "POST",
                data: {
                    doc_path : file,
                    bill_id: billId,
                    flag:flag
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-inv-view-doc-remove')
                }
            });
        },
        removeAllFiles() {
            var self = this;
            self.$refs.vendorInvoiceDropzone.removeAllFiles();
        },
        storeBillDoc() {
            var self = this;
            var error = false;
            self.doc_error_msg = "";
            if (!self.uploadDocs.length){
                self.doc_error_msg = 'File Required';
                error = true;
            }
            if (self.uploadDocs.length > 0) {
                if (self.validateDocs.length > 0) {
                    for (var i = 0;i < self.validateDocs.length;i++) {
                        let fileObj = self.validateDocs[i];

                        if (fileObj.extension != undefined) {
                          if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf" || fileObj.extension == "doc" || fileObj.extension == "docx" || fileObj.extension == "msword" || fileObj.extension == "vnd.openxmlformats-officedocument.wordprocessingml.document") {

                            }else{
                                self.doc_error_msg = "Only Images or PDF or Doc Files Are Allowed (.jpg / .jpeg / .png / .pdf / .doc / .docx).";
                                error = true;
                            }
                        }

                        if (fileObj.size != undefined) {
                            if(fileObj.size > 5000000){
                                self.doc_error_msg = "File Size Should Not Be Greater Than 5 MB.";
                                error = true;
                            }
                        }
                    }
                }
            }
            if (!error) {
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[3])
                {
                    $("#uploadVendorInvDoc").val("Saving ...");
                    $("#uploadVendorInvDoc").prop("disabled", true);

                }

                var fields = [];

                if(self.uploadDocs.length > 0){
                    fields.push({name: "doc_path", value: JSON.stringify(self.uploadDocs)});
                }else{
                    fields.push({name: "doc_path", value: null});
                }
                fields.push({name: "id", value: segments[3]});

                $.ajax({
                    url: process.env.ROOT_API + "/vendor-inv-doc/upload",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#uploadVendorInvDoc").val("Save");
                            $("#uploadVendorInvDoc").prop("disabled", false);
                        }
                        self.validateDocs = [];
                        self.uploadDocs = [];
                        self.removeAllFiles();
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }else{
                            self.$swal('',data.message,'success');
                        }
                        self.loadBillDetail(segments[3]);

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                            if (segments[3])
                            {
                                $("#uploadVendorInvDoc").val("Save");
                                $("#uploadVendorInvDoc").prop("disabled", false);
                            };
                        self.generateStatusCodeMessage(jqXHR,true,'vendor-inv-doc-upload')
                    }
                });
            }
        }

    }


}
</script>




// WEBPACK FOOTER //
// src/components/accounting/BillView.vue